export default __webpack_public_path__ + "static/media/tutorial_1.6ec32f4c.svg";